import Loader from '@anm/components/Loader';
import TitleBlock, { TitleBlockWrapper } from '@anm/components/TitleBlock';
import { sectionTitleCSS } from '@anm/components/video-landings/SectionTitle';
import { CUSTOMIZATION_CONTENT_COLUMN_MAX_WIDTH, HEADER_HEIGHT_MOBILE } from '@anm/styles/constants';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { ContentWrapper, NavButton } from '../../layouts/LeftBarLayout';
import { Navbar } from '../../layouts/LeftBarLayout/Wrapper';
import RightPanelWrapper from '../CustomizationSection/RightPanel/Wrapper';

type WrapperProps = {
  isLandingScreen?: boolean;
};

const sectionWrapperMobile = media.phone`
  ${RightPanelWrapper} {
    width: 100%;
  }
`;

const navBarOnMobiles = media.tablet`
    position: static;
    top: unset;
    max-width: 100%;
`;

const sectionWrapperTablet = media.tablet<WrapperProps>`
  flex-direction: column;
  justify-content: flex-start;
  & > * {
    order: ${({ isLandingScreen }) => (isLandingScreen ? 2 : 1)};
    flex-grow: initial;
    background-color: inherit;
  }
  ${ContentWrapper}, ${RightPanelWrapper} {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    border-top: 0 none;
  }
  ${ContentWrapper} {
      order: 2;
      border-right: 0;
  }
  ${RightPanelWrapper} {
    max-width: ${CUSTOMIZATION_CONTENT_COLUMN_MAX_WIDTH};
    order: ${({ isLandingScreen }) => (isLandingScreen ? 2 : 1)};
    align-self: center;
    width: 100%;
    padding: ${({ isLandingScreen }) => (isLandingScreen ? 0 : '0 20px')};
  }
  ${Navbar} {
    background-color: #fff;
    position: sticky;
    top: ${HEADER_HEIGHT_MOBILE};
    ${navBarOnMobiles}
  }
`;

const sectionWrapperSmallScreen = media.desktop_small<WrapperProps>`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  & > * {
    order: ${({ isLandingScreen }) => (isLandingScreen ? 2 : 1)};
  }
  ${Navbar} {
    width: 100%;
  }
  ${ContentWrapper}:last-child {
    width: 100%;
    max-width: 100%;
    border: 0 none;
  }
  ${ContentWrapper}, ${RightPanelWrapper} {
    border-top: 1px solid #ccdde6;
  }
  ${RightPanelWrapper} {
    order: 2;
    max-width: calc(100% - 450px);
  }
  ${NavButton}:last-of-type {
    margin-top: 5px;
  }
`;

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: flex;
  flex-grow: 1;
  z-index: 1;

  ${sectionWrapperSmallScreen};
  ${sectionWrapperTablet};
  ${sectionWrapperMobile};
`;

export const subTitleStyles = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.01em;
    color: #919eaa;
    font-weight: normal;
  }
`;

export const SectionSubTitle = styled(TitleBlock)`
  ${subTitleStyles}
`;

export const titleWithToglerStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  ${TitleBlockWrapper} {
    margin-bottom: 0;
  }
`;

export const TitleWithToggler = styled.div`
  ${titleWithToglerStyles}
`;

const sectionTitleOnMobiles = media.tablet`
  display: none;
`;

export const tabTitleStyles = css`
  ${sectionTitleCSS};
  ${sectionTitleOnMobiles};
`;

export const TabTitle = styled(TitleBlock)`
  ${tabTitleStyles};
`;

export const LoaderWrapper = styled(Loader)`
  margin-top: 100px;
`;
